export default {
  away: {},
  items: [],
  pagination: {},
  isBusy: false,
};
